var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":_vm.name,"type":"hidden","name":_vm.name},domProps:{"value":_vm.value}}),_vm._v(" "),_c('trix-editor',{ref:"trix",attrs:{"input":_vm.name,"placeholder":_vm.placeholder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }